import type { FC, ReactNode } from 'react';

type Props = {
  /** フッター内に表示するコンテンツ（ボタン等） */
  children: ReactNode;
};

/**
 * サイドメニューのフォームフッター
 *
 * SidePanel下部に固定表示されるフッター。
 * 親要素が flex-col レイアウトであることを前提とし、
 * スクロール領域（flex-1 min-h-0 overflow-y-auto）の後に配置することで
 * パネル下端に固定される。
 *
 * SideMenuHeader と同じ幅・パディングで統一。
 */
export const SideMenuFormFooter: FC<Props> = ({ children }) => {
  return (
    <div className="flex shrink-0 items-center justify-end gap-2 border-t bg-white px-4 py-3">
      {children}
    </div>
  );
};
